<template>
    <div class="additional-accessories">
        <h3>{{translate('additional_accessories')}}</h3>
        <ul>
            <li class="checkbox" v-for="(element, id) in accessories">
                <input type="checkbox" @click="toggleAdditionalAccessoriesAction(id)" :checked="isCurrentActive(id)" :disabled="!isEditable">
                <label/>
                <div class="accessory-data" @click="toggleAdditionalAccessoriesAction(id)">
                    <span>
                        {{translate(element.title)}}
                    </span>
                    <span>
                        <span v-if="getFanCount > 1">
                            {{getFanCount}} x
                        </span>
                        {{ $priceController.convertWithThousandSeparator(calculateDiscount(element.price)) }} Euro
                    </span>
                </div>
            </li>
        </ul>

        <div class="summary">
            <p>{{translate('surcharge')}}: <span v-html="$priceController.convertWithThousandSeparator(parseFloat(accessoriesSum * getFanCount).toFixed(2))"/><span>Euro</span></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "additional_accesories",
        data() {
            return {
                accessoriesSum: 0
            }
        },
        methods: {
            calculateDiscount(price){
                return parseFloat(this.$priceController.calculateDiscount(price, this.$store.state.discount)).toFixed(2);
            },

            toggleAdditionalAccessoriesAction(id){
                if(this.isEditable){
                    this.toggleAdditionalAccessories(id);
                }
            },

            toggleAdditionalAccessories(id) {
                this.$store.commit({
                    type: 'toggleAdditionalAccessories',
                    id: id
                });
                this.sumAdditionalAccessoriesPrice();
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            sumAdditionalAccessoriesPrice() {
                let sum = 0;

                this.$store.state.productCard.custom.accesories.values.add_accessories.values.forEach((accesory) => {
                    if (accesory.isActive) {
                        sum += parseFloat(this.calculateDiscount(parseFloat(accesory.price)));
                    }
                });

                this.$store.state.productCard.custom.accesories.sumAdditionalAccessoriesPrice = sum;
                this.accessoriesSum = sum;
                return sum;
            }

        },

        computed: {
            accessories() {
                return this.$store.state.productCard.custom.accesories.values.add_accessories.values;
            },
            isCurrentActive() {
                return function(id){
                    let activeFlag =  this.$store.state.productCard.custom.accesories.values.add_accessories.values[id].isActive === true;
                    return activeFlag;
                }
            },
            getCurrencyUnit() {
                return this.$store.state.ValueUnitMap.price.selected;
            },
            getFanCount() {
                return this.$store.state.workPointParameters.elements.number_of_fans.value;
            },
            isEditable() {
                return this.$store.getters.isOfferEditable;
            }
        },

        mounted() {
            this.sumAdditionalAccessoriesPrice();
        }
    }
</script>